export default __webpack_public_path__ + "assets/audios/75a1d422afb6185d19d04098e6a30c10.mp3";